import { render } from "./ProjectSection.vue?vue&type=template&id=0c608f00&scoped=true"
const script = {}

import "./ProjectSection.vue?vue&type=style&index=0&id=0c608f00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c608f00"]])

export default __exports__